var map = {
	"./Admin/Create": 6670,
	"./Admin/Create.vue": 6670,
	"./Admin/Index": 5813,
	"./Admin/Index.vue": 5813,
	"./Dashboard/Index": 2439,
	"./Dashboard/Index.vue": 2439,
	"./Hmo/Create": 3873,
	"./Hmo/Create.vue": 3873,
	"./Hmo/Index": 9384,
	"./Hmo/Index.vue": 9384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;